// sirve para buscar etiquetas XML en el docx para no romper otra
//busca la mas cercana de apertura y la mas cercana de cierre
/*export function buscaetiqueta(xml, index, tagName) {
  const before = xml.slice(0, index)
  const startTagIndex = before.lastIndexOf(`<${tagName}`)
  if (startTagIndex === -1) return null

  const after = xml.slice(index)
  const endTagRelative = after.indexOf(`</${tagName}>`)
  if (endTagRelative === -1) return null

  const endTagIndex = index + endTagRelative + `</${tagName}>`.length
  return { start: startTagIndex, end: endTagIndex }
}*/


export function buscaetiqueta(xml, fromIndex, tagName) {
  const openStart = xml.indexOf(`<${tagName}`, fromIndex)
  if (openStart === -1) return null
  const openEnd = xml.indexOf('>', openStart)
  if (openEnd === -1) return null
  const closeTag = `</${tagName}>`
  const closeIdx = xml.indexOf(closeTag, openEnd)
  if (closeIdx === -1) return null
  return { start: openStart, end: closeIdx + closeTag.length }
}